import PropTypes from 'prop-types';
import React, { useContext, useMemo } from 'react';

const Context = React.createContext({});
const { Consumer, Provider } = Context;

const useModalContext = () => useContext(Context);

const ModalProvider = ({ children, onCancel, onClose }) => {
  const value = useMemo(() => ({ onCancel, onClose }), [onCancel, onClose]);

  return <Provider value={value}>{children}</Provider>;
};

ModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
};

export default Context;
export { Consumer, ModalProvider as Provider, useModalContext };
